// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"abb49ae3","926":"36407f91"}[chunkId] + ".chunk.css";
};